import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { useState } from 'react';
import formatTimeString from '../../utils/formatTimeString';
import availTimes from '../../utils/availTimes';
import {
  packagePrice,
  packagePricePreTax,
  packagePriceTax
} from '../../utils/packagePrice';
import Price from '../common/Price';
import TickBox from '../common/TickBox';
import { parseISOLocal } from '../../utils/date';
import { isAfter } from 'date-fns';
import { useDebouncedCallback } from 'use-debounce';

export const PackageAddOnItem = ({
  addOn,
  qty,
  minQty,
  maxQty,
  time,
  limit,
  disabled,
  onQtyChange,
  onTimeChange,
  maxMet,
  minMet,
  sale,
  config,
  autoAdded
}) => {
  const [addOnQty, setAddOnQty] = useState(qty);
  const [addOnTime, setAddOnTime] = useState(time);

  const [debouncedQtyChangeCallback] = useDebouncedCallback(() => {
    onQtyChange(addOnQty);
  }, 500);

  const [debouncedTimeChangeCallback] = useDebouncedCallback(() => {
    onTimeChange(addOnTime);
  }, 500);

  const _availTimes = availTimes(addOn, sale);
  const now = new Date();
  const todaysTimes = _availTimes
    ? Object.keys(_availTimes)
        // make sure it's available
        .filter(timeProp => {
          var timeObj = _availTimes[timeProp];
          var date = parseISOLocal(
            timeObj['prop-start_time'].replace(
              /(\d{4})(\d{2})(\d{2}) (.+)/,
              '$1-$2-$3T$4'
            )
          );

          var timeIsFuture = isAfter(date, now);
          return timeObj['prop-m4s'] > 0 && timeIsFuture;
        })
    : [];
  const timesAvailable = todaysTimes !== null && todaysTimes.length > 0;
  const price = packagePrice(addOn, sale);
  const pricePreTax = packagePricePreTax(addOn, sale);

  return (
    <div key={addOn.item_id} className="swformfield-tktpackage-lineitem__addon">
      <div className="swformfield swformfield--inputgroup">
        <label className="swformfield__label">{addOn.descrip}</label>

        <TickBox
          value={addOnQty}
          onChange={qty => {
            setAddOnQty(qty);
            if (qty < 1) {
              setAddOnTime('');
            }
            debouncedQtyChangeCallback();
          }}
          disabled={disabled || (autoAdded && maxMet && minMet)}
          disablePlus={maxMet}
          disableMinus={autoAdded && minMet}
          min={minQty}
          max={maxQty}
        />
        {timesAvailable && (
          <>
            <div
              className={classNames({
                ['swformfieldwrapper']: true,
                ['swformfieldwrapper--timeandqty']: limit > 1
              })}
            >
              <select
                disabled={!addOnQty}
                value={addOnTime}
                className="swformfield__control form-control"
                onChange={e => {
                  const time = e.target.value;
                  setAddOnTime(time);
                  debouncedTimeChangeCallback();
                }}
              >
                <option value="">Select time</option>
                {todaysTimes.map(timeProp => {
                  var time = timeProp.replace('prop-', '');
                  var timeObj = _availTimes[timeProp];
                  var limit = parseInt(timeObj['prop-m4s'], 10);
                  limit = limit > -1 ? limit : 0;

                  var price = packagePrice(addOn, sale, time);
                  var pretax = packagePricePreTax(addOn, sale, time);
                  var tax = packagePriceTax(addOn, sale, time);

                  return (
                    <option
                      key={time}
                      value={time}
                      data-price={price}
                      data-pretax={pretax}
                      data-tax={tax}
                      data-limit={limit}
                    >
                      {formatTimeString(sale.day, time)}
                    </option>
                  );
                })}
              </select>
            </div>
          </>
        )}

        <div className="swformfieldtotal">
          {config.taxInclusive ? (
            <Price price={price} showZero={true} />
          ) : (
            <Price price={pricePreTax} showZero={true} />
          )}{' '}
        </div>
      </div>
    </div>
  );
};

PackageAddOnItem.propTypes = {
  addOn: PropTypes.object,
  qty: PropTypes.number,
  minQty: PropTypes.number,
  maxQty: PropTypes.number,
  time: PropTypes.string,
  limit: PropTypes.number,
  disabled: PropTypes.bool,
  onQtyChange: PropTypes.func,
  onTimeChange: PropTypes.func,
  maxMet: PropTypes.bool,
  minMet: PropTypes.bool,
  sale: PropTypes.object,
  config: PropTypes.object,
  autoAdded: PropTypes.bool
};

export default PackageAddOnItem;
